@if (!tournaments()?.list?.length) {
  Lista vacía
} @else {
  <mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
  >
    <!-- <mat-card-header>
      <mat-card-title>
        <button
          mat-button
          class="text-daxa p-0 h-auto"
        >
          + Nuevo torneo
        </button>
      </mat-card-title>
      <mat-card-subtitle>
        <!- <button
          type="button"
          mat-button
          class="card-header-menu-btn"
          [matMenuTriggerFor]="cardHeaderMenu"
        >
          Show All
        </button>
        <mat-menu
          #cardHeaderMenu="matMenu"
          class="card-header-menu"
          xPosition="before"
        >
          <button mat-menu-item>
            Shipped
          </button>
          <button mat-menu-item>
            Confirmed
          </button>
          <button mat-menu-item>
            Pending
          </button>
          <button mat-menu-item>
            Rejected
          </button>
        </mat-menu> ->

        <!- <form class="search-box position-relative">
          <i class="material-symbols-outlined">
            search
          </i>
          <input
            #input
            type="text"
            class="input-search d-block w-100 border-none outline-0"
            placeholder="Search here..."
            (keyup)="applyFilter($event)"
          />
        </form> ->
      </mat-card-subtitle>
    </mat-card-header> -->

    <mat-card-content>
      <div class="recent-orders-table">
        <!-- <div class="table-responsive"> -->
        <table mat-table [dataSource]="dataSource()">

          <!-- Name -->
          <ng-container matColumnDef="name" sticky>
            <th mat-header-cell *matHeaderCellDef>
              Nombre
            </th>
            <td mat-cell *matCellDef="let element" class="text-black">
              {{ element.name }}
            </td>
          </ng-container>

          <!-- Event -->
          <ng-container matColumnDef="event">
            <th mat-header-cell *matHeaderCellDef>
              Clasificación general
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.event?.name }}
            </td>
          </ng-container>

          <!-- Location -->
          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef>
              Sede
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.location?.name }}
            </td>
          </ng-container>

          <!-- Modality -->
          <ng-container matColumnDef="modality">
            <th mat-header-cell *matHeaderCellDef>
              Modalidad
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.modality }}
            </td>
          </ng-container>

          <!-- Start date -->
          <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef class="text-right">
              Fecha de inicio
            </th>
            <td mat-cell *matCellDef="let element" class="text-right">
              {{ element.startDate | date: 'dd/MM/yyy' }}
            </td>
          </ng-container>

          <!-- End date -->
          <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef class="text-right">
              Fecha de finalización
            </th>
            <td mat-cell *matCellDef="let element" class="text-right">
              {{ element.endDate | date: 'dd/MM/yyy' }}
            </td>
          </ng-container>

          <!-- Options -->
          <ng-container matColumnDef="options" stickyEnd>
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <a
                mat-button
                [routerLink]="['./', element.strId]"
                class="link-btn text-body"
              >
                <i class="material-symbols-outlined">
                  east
                </i>
              </a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <!-- <td class="mat-cell" colspan="4">No data matching the filter "{{ input.value }}"</td> -->
            <td class="mat-cell" colspan="4">No data matching the filter</td>
          </tr>
        </table>
        <!-- </div> -->

        <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator> -->
      </div>
    </mat-card-content>
  </mat-card>
}
